import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA  } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CKEditorModule } from 'ng2-ckeditor';
import { AppComponent } from './app.component';
import {FormsModule} from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { ReactiveFormsModule } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CommonModule} from '@angular/common';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {ToastrModule} from "ngx-toastr";
import {LenguageModule} from "./lenguage/lenguage.module";

@NgModule({
  declarations: [AppComponent],
  imports: [
      BrowserModule,
      CommonModule,
      LenguageModule,
      MDBBootstrapModule.forRoot(),
      HttpClientModule,
      CKEditorModule,
      FormsModule,
      ReactiveFormsModule,
      NgProgressModule,
      BrowserAnimationsModule, // required animations module
      ToastrModule.forRoot(), // ToastrModule added
  ],
  bootstrap: [AppComponent],
  schemas: [ NO_ERRORS_SCHEMA ]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/app.module.ts